import { render, staticRenderFns } from "./QuickStartCard.vue?vue&type=template&id=4bab4618&scoped=true&"
import script from "./QuickStartCard.vue?vue&type=script&lang=ts&"
export * from "./QuickStartCard.vue?vue&type=script&lang=ts&"
import style0 from "./QuickStartCard.vue?vue&type=style&index=0&id=4bab4618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab4618",
  null
  
)

export default component.exports